<template>
  <div>
    <div class="error w">
      <!-- 错误报告 -->
      <!-- <div class="report fl">
        <h3>エラー報告</h3>
        <div class="choose">
          <ul>
            <el-radio-group v-model="radio">
              <li>
                <el-radio :label="1"
                  >検索キーワードと違う商品bンが出てきた</el-radio
                >
              </li>
              <li>
                <el-radio :label="2">検索結果がない</el-radio>
              </li>
              <li>
                <el-radio :label="3">検索エラー </el-radio>
              </li>
              <li>
                <el-radio :label="4">その他</el-radio>
              </li>
            </el-radio-group>
          </ul>
          <div class="suggest">
            <el-input
              type="textarea"
              placeholder="問題詳細"
              v-model="suggest"
              resize="none"
              autosize
            ></el-input>
          </div>
          <a href="javascript:;" style="background: #F3C622">提出</a>
          <a href="javascript:;">キャンセル</a>
        </div>
      </div> -->
      <div class="duibuqi">
        <div class="img">
          <img src="../../assets/img/duibuqi.png" alt />
        </div>

        <p>“{{ $route.query.result }}” の商品見つけられませんでした</p>
        <p>お手数をおかけしますが、担当者までご連絡ください。</p>

        <!-- <router-link to="/">問題報告</router-link> -->
        <router-link to="/" style="margin-left: 32px">
          トップページへ</router-link
        >
        <!-- <h6>
          <img src="../../assets/img/hua.png" alt />
          ご報告ありがとうございました。確認後、修正させていただきます。
        </h6> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.error {
  overflow: hidden;
  .report {
    width: 350px;
    margin-top: 72px;
    h3 {
      height: 40px;
      background: #f3c622;
      color: #333;
      font-size: 16px;
      font-weight: 700;
      padding-left: 20px;
      line-height: 40px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .choose {
      width: 318px;
      height: 350px;
      padding-left: 30px;
      border: 1px solid #ccc;
      ul {
        li {
          font-size: 14px;
          color: #333;
          margin-top: 17px;
        }
      }
      .suggest {
        width: 290px;
        height: 144px;
        margin-top: 26px;
        .el-input__inner {
          width: 100%;
          height: 144px !important;
        }
      }
      a {
        float: right;
        text-align: center;
        height: 30px;
        // width: 60px;
        padding: 0 15px;
        font-size: 16px;
        line-height: 30px;
        color: #333;
        border: 1px solid #ccc;
        margin-right: 30px;
      }
    }
  }
  .duibuqi {
    overflow: hidden;
    width: 540px;
    margin: 100px auto;
    text-align: center;
    .img {
      transform: translate(-40px, -50px);
    }
    p {
      font-size: 20px;
      font-weight: 700;
      margin: 32px 0 32px 15px;
      color: #333;
    }
    a {
      text-align: center;
      color: #f3c622;
      text-decoration: underline;
      font-size: 16px;
      font-weight: 700;
      margin-left: 92px;
      line-height: 25px;
    }
    h6 {
      width: 480px;
      height: 38px;
      border: 1px solid #f3c622;
      color: #f3c622;
      font-size: 16px;
      font-weight: 700;
      line-height: 38px;
      img {
        vertical-align: middle;
        margin-left: 20px;
      }
    }
  }
}
</style>